<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Regla de Tarifas</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
        @click="_guardarReglaTarifa(false)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
      </v-chip>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarReglaTarifa(true)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
      </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4">

            <v-select v-model="modelReglaTarifa.nombre" :items="temporadas" item-text="label" item-value="value"
              outlined dense label="Selecciona nombre de la temporada" @change="_changeTemporada">
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center">
                  <v-chip label :color="item.color" class="mr-2" small></v-chip>
                  <span>{{ item.label }}</span>
                </div>
              </template>
            </v-select>



            <!--    <v-text-field v-model="modelReglaTarifa.nombre" outlined label="Nombre" dense :dark="dark"
              autocomplete="off"></v-text-field>
              -->


          </v-row>

          <v-row dense class="mx-4">
            <v-col>
              <v-menu :dark="dark" v-model="showFechaDesde" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :dark="dark" class="mr-2" clearable dense outlined
                    v-model="modelReglaTarifa.fecha_desde" label="Fecha desde" prepend-inner-icon="mdi-calendar"
                    readonly v-on="on" hide-details></v-text-field>
                </template>
                <v-date-picker :dark="dark" color="success" locale="es" v-model="modelReglaTarifa.fecha_desde"
                  @input="showFechaDesde = false" @change="_changeFechaDesde()" first-day-of-week="1"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <v-menu :dark="dark" v-model="showFechaHasta" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field class="ml-2" :dark="dark" clearable dense outlined
                    v-model="modelReglaTarifa.fecha_hasta" label="Fecha hasta" prepend-inner-icon="mdi-calendar"
                    readonly v-on="on" hide-details></v-text-field>
                </template>
                <v-date-picker :dark="dark" color="success" locale="es" v-model="modelReglaTarifa.fecha_hasta"
                  @input="showFechaHasta = false" first-day-of-week="1" @change="_changeFechaHasta()"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>




          <v-row dense class="mx-4 mb-4 mt-12">
            <h3>Seleccione los días de la semana en los que se aplicará la regla de tarifas.</h3>

            <v-radio-group v-model="tipoDiasSemanaSeleccionado">
              <v-radio v-for="tipo in tiposDiasSemanas" return-object :key="tipo.label" :label="tipo.label"
                :value="tipo" class="mb-2"></v-radio>
            </v-radio-group>





          </v-row>



        </v-col>

        <v-divider vertical></v-divider>

        <v-col class="ml-0">

          <v-data-table locale="es" dense :headers="headersTarifas" :items="tarifasConPrecio"
            :items-per-page="tarifasConPrecio.length" class="elevation-1 alternating-rows bordered-table mx-4 mb-6"
            hide-default-footer>
            <template v-slot:top>
              <v-toolbar dense :color="colorBarraFormulario" dark flat>
                <v-toolbar-title>Tarifas disponibles</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:item.precio="{ item }">
              <v-text-field :disabled="tarifasDeshabilitadas" class="mt-2 mb-2 text-right" v-model="item.precio"
                outlined dense hide-details></v-text-field>
            </template>

            <template v-slot:no-data>
              No hay tarifas disponibles
            </template>

          </v-data-table>

        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ReglaFormulario",
  components: {},
  data: () => ({
    loading: false,
    tarifasDeshabilitadas: false,

    showFechaDesde: false,
    showFechaHasta: false,

    tarifasConPrecio: [],

    tiposDiasSemanas: [{
      label: "Todos los días",
      dia_desde: 0,
      dia_hasta: 6,
    },
    {
      label: "De Lunes a Jueves",
      dia_desde: 1,
      dia_hasta: 4,
    },
    {
      label: "De Lunes a Viernes",
      dia_desde: 1,
      dia_hasta: 5,
    },
    {
      label: "Sábados y Domingos",
      dia_desde: 6,
      dia_hasta: 0,
    },
    {
      label: "Viernes, Sabados y Domingos",
      dia_desde: 5,
      dia_hasta: 0,
    }],

    tipoDiasSemanaSeleccionado: {
      label: "Todos los días",
      dia_desde: 0,
      dia_hasta: 6,
    },

    headersTarifas: [
      { text: 'REGIMEN', value: 'regimen_titulo' },
      { text: 'HABITACION-CARACTERISTICA', value: 'habitacion_caracteristica_titulo' },
      { text: 'PRECIO', value: 'precio', width: '200px' },
    ],

    temporadaSeleccionada: null,
    temporadas: [
      { label: "Temporada Baja", value: "Temporada Baja", color: "green" },
      { label: "Temporada Media", value: "Temporada Media", color: "blue" },
      { label: "Temporada Alta", value: "Temporada Alta", color: "orange" },
      { label: "Temporada Especial", value: "Temporada Especial", color: "yellow" },
      { label: "Cierre", value: "Cierre", color: "red" },
    ],

  }),

  props: {
    modelReglaTarifa: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorFondoDialog",
      "colorBarraFormulario",
      "tiposCliente",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("proveedores", [
      "proveedorSelec"
    ]),
  },



  mounted() {
    console.log('entranemounted');
    this._inicializarDatos();
  },

  watch: {
    modelReglaTarifa(newVal) {
      console.log('entranewatch');
      this._inicializarDatos();
    }
  },

  methods: {
    ...mapActions("reglas", ["crearRegla", "updateRegla", "getReglasFromProveedor"]),

    _inicializarDatos() {
      if (this.accion == "crear") {
        this.tarifasConPrecio = this.proveedorSelec.tarifas;
      } else if (this.accion == "editar") {
        this.tarifasConPrecio = this.modelReglaTarifa.tarifas;
      } else if (this.accion == "duplicar") {
        this.tarifasConPrecio = this.modelReglaTarifa.tarifas;
      }
      this._actualizarDatosDiaSemana();
    },

    _actualizarDatosDiaSemana() {
      console.log('entroaqui');
      if (this.accion == "editar" || this.accion == "duplicar") {
        this.tipoDiasSemanaSeleccionado = this.tiposDiasSemanas.find(tipo => tipo.dia_desde === this.modelReglaTarifa.dia_desde && tipo.dia_hasta === this.modelReglaTarifa.dia_hasta);
      } else {
        this.tipoDiasSemanaSeleccionado = {
          label: "Todos los días",
          dia_desde: 0,
          dia_hasta: 6,
        };
      }
    },

    _reiniciarTarifas() {
      this.tarifasConPrecio.forEach(tarifa => {
        tarifa.precio = 0;
      });
    },


    _changeTemporada(item) {
      console.log('item:', this.modelReglaTarifa.nombre);
      if (item == "Cierre") {
        this._reiniciarTarifas();
        this.tarifasDeshabilitadas = true;
      } else {
        this.tarifasDeshabilitadas = false;
      }
    },


    _changeFechaDesde() {
      console.log(this.modelReglaTarifa.fecha_desde);
    },

    _changeFechaHasta() {
      console.log(this.modelReglaTarifa.fecha_hasta);
    },





    _cerrarVentana() {
      this.$emit("cerrarFormularioReglaTarifa");
    },

    async _guardarReglaTarifa(cerrar) {
      if (this.tipoDiasSemanaSeleccionado != null) {
        this.modelReglaTarifa.dia_desde = this.tipoDiasSemanaSeleccionado.dia_desde;
        this.modelReglaTarifa.dia_hasta = this.tipoDiasSemanaSeleccionado.dia_hasta;
      }
      let mTarifasReglas = [];
      for (let i = 0; i < this.tarifasConPrecio.length; i++) {
        let mTarifaRegla = {
          tarifa_id: this.tarifasConPrecio[i].id,
          precio: parseFloat(this.tarifasConPrecio[i].precio.toString().replace(/,/g, '.')),
        }
        mTarifasReglas.push(mTarifaRegla);
      }
      this.loading = true;
      if (this.accion == "crear" || this.accion == "duplicar") {
        var res = await this.crearRegla([
          this.access_token,
          this.modelReglaTarifa,
          mTarifasReglas,
        ]);

      } else if (this.accion == "editar") {
        var res = await this.updateRegla([
          this.access_token,
          this.modelReglaTarifa,
          mTarifasReglas,
        ]);

      }
      if (cerrar) {
        this._cerrarVentana();
        await this.getReglasFromProveedor([this.access_token, this.proveedorSelec.id, true]);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
  /* Alineación a la derecha */
}
</style>
